import React, { ReactNode } from 'react';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { SelectCallback } from 'react-bootstrap/esm/helpers';
import styled from 'styled-components/macro';
import cx from 'classnames';

type Props = {
  menuOptions: Array<{ id: string; title: string; intlID: string }>;
  isOffCenter?: boolean;
  onChange: (key: string | null) => void;
  className?: string;
  value: string;
  title?: ReactNode;
};

export const SortDropdown = (props: Props) => {
  const { menuOptions, value, title, isOffCenter, className, onChange } = props;

  const activeOption = menuOptions.find((e) => e.id === value);

  const handleSelect: SelectCallback = (key, e) => {
    e.preventDefault();
    onChange(key);
  };

  return (
    <Wrapper className={cx(className, 'sort-dropdown-container', { center: isOffCenter })}>
      <DropdownButton
        id="dropdown"
        className="sort-dropdown"
        onSelect={handleSelect}
        title={
          <span>
            {title || 'Sort By:'}
            <span className="dropdown-text text-primary">{activeOption?.title}</span>
            {/* <FontAwesomeIcon icon={faCaretDown} /> */}
            <span className="caret" />
          </span>
        }
      >
        {menuOptions.map((sortType) => (
          <Dropdown.Item eventKey={sortType.id} active={sortType.id === value} key={sortType.id}>
            {sortType.title}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-right: 10px;
  vertical-align: middle;

  & .btn {
    background: transparent !important;
    box-shadow: transparent !important;
    border-color: transparent !important;
    color: ${(props) => props.theme.primary7};

    :hover,
    :active,
    :focus,
    :active:focus,
    :active:hover {
      color: ${(props) => props.theme.primary7};
    }
  }

  & .center {
    margin-bottom: 0;
    margin-right: 30px;
  }

  & .sort-dropdown {
    border: 0;
    letter-spacing: 0.5px;
    font-size: 1rem;
  }

  & .caret {
    margin-left: 8px;
  }

  .text-primary {
    margin-left: 0.25em;
  }
`;
